var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1022,
    height: 1060,
    viewBox: "0 0 1022 1060",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M510.977 1059.04C792.629 1059.04 1020.96 822.187 1020.96 530.018C1020.96 237.849 792.629 1 510.977 1C229.324 1 1 237.849 1 530.018C1 822.187 229.324 1059.04 510.977 1059.04Z",
    stroke: "url(#paint0_linear_5_440)",
    strokeWidth: 1.62651,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_440",
    x1: 510.937,
    y1: 0.4803,
    x2: 510.937,
    y2: 1059.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161A24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#161A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161A24",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.d6f1633e8be505252e9794f13ad49ecc.svg";
export { ForwardRef as ReactComponent };